export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export function waLink(number, text) {
  return `https://wa.me/${String(number || "").replace(/\D/g, "")}?text=${encodeURIComponent(text)}`;
}

export function fmtPhone(number) {
  const d = String(number || "").replace(/\D/g, "");
  if (d.length === 12 && d.startsWith("91")) return `+91 ${d.slice(2, 7)} ${d.slice(7)}`;
  if (d.length === 10) return `+91 ${d.slice(0, 5)} ${d.slice(5)}`;
  return d ? `+${d}` : "";
}
